import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, DestroyRef, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { environment } from 'src/environments/environment';
import { VersionCheckService } from './core/services/version-check.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  title = 'Deben Admin';

  // Version update state
  showUpdateBanner = false;
  newVersion = '';

  constructor(public _translate: TranslateService,
    @Inject(DOCUMENT) private document: Document,
    private versionCheck: VersionCheckService) {

  }

  ngOnInit() {
    let lang = localStorage.getItem('language') || 'en'
    this.defaultLanguage(lang);
    this.setPageDirection(lang)

    if (this.shouldLoadSmartlook()) {
      this.loadSmartlookScript();
    }

    // Start version checking
    // this.versionCheck.startVersionCheck()
    //   .pipe(takeUntilDestroyed(this.destroyRef))
    //   .subscribe((versionInfo) => {
    //     this.handleNewVersion(versionInfo.version);
    //   });
  }

  private shouldLoadSmartlook(): boolean {
    if (!environment.smartlook?.enabled) return false;

    const currentHostname = window.location.hostname;
    return environment.smartlook.allowedDomains.some(domain =>
      currentHostname === domain || currentHostname.includes(domain)
    );
  }

  loadSmartlookScript(): void {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'assets/scripts/smartlook.js'; // Path to Smartlook script
    script.async = true;
    document.head.appendChild(script);
  }

  setPageDirection(val = 'en') {
    this.document.documentElement.dir = ((val == 'en') ? 'ltr' : 'rtl');
    this.document.documentElement.lang = ((val == 'en') ? 'en' : 'ar');
  }

  defaultLanguage(lang: any = 'en') {
    this._translate.setDefaultLang(lang || 'en');
    this._translate.use(lang || 'en');
    localStorage.setItem('language', lang || 'en');
  }

  /**
   * Handle new version detection
   */
  private handleNewVersion(version: string): void {
    this.newVersion = version;
    this.showUpdateBanner = true;
    console.log('[App] New version available:', version);
  }

  /**
   * Refresh application to load new version
   */
  public refreshApp(): void {
    console.log('[App] User triggered refresh for version:', this.newVersion);
    location.reload();
  }

  /**
   * Dismiss update banner (will show again on next check)
   */
  public dismissUpdateBanner(): void {
    this.showUpdateBanner = false;
  }

  // No ngOnDestroy needed - takeUntilDestroyed handles cleanup automatically
}

